import { createSlice } from "@reduxjs/toolkit";
import { getAuthUser } from "../actions/user";

const states = {
  user: null,
  loading: false,
  error: false,
};

export const authUser = createSlice({
  initialState: states,
  name: "authUser",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAuthUser.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getAuthUser.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.user = action.payload.data?.data;
    });
    builder.addCase(getAuthUser.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
  },
});

export default authUser.reducer;
